module.exports = __webpack_public_path__ + "static/img/img17.216ca74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img17.jpg
// module id = bvPL
// module chunks = 1